export const UiDesignModuleTranslations: Array<string> = [
  // title
  'xmlResponsiveTemplates',

  // responsive templates
  'Admin.ResponsiveTempltes.CustomTemplateName',
  'Admin.ResponsiveTempltes.ResponsiveTemplateName',
  'Admin.ResponsiveTempltes.PageName',
  'Admin.ResponsiveTempltes.Content',
  'Admin.ResponsiveTempltes.IsDefault',
  'Admin.ResponsiveTempltes.ModifiedBy',
  'Admin.ResponsiveTempltes.ModifiedOn',
  'Admin.ResponsiveTempltes.FreezePage',
  'Admin.ResponsiveTempltes.Description',
  'Admin.Responsive.Template',
  'Admin.Responsive.Page',
  'Admin.Responsive.DefineNewResponsiveTemplate',
  'Admin.appParams.UseFiori3Styles',
  'Admin.Responsive.TemplateVersions',
  'Admin.Responsive.DefaultTemplate',
  'Admin.Responsive.NewTemplate',
  'ResponsiveUITemplate.TemplatesResetOccured',
  'ResponsiveUITemplate.FreezeTemplatesPreviousVersion',
  'ResponsiveUITemplate.FreezeTemplatesWillRemainFreezed',
  'ResponsiveUITemplate.OpenResponsiveTemplatePages',
  'Admin.ResponsiveTempltes.ResponsiveTemplateNew',
  'Admin.ResponsiveTempltes.AreYouSureYouWantToFrrezeUnfreezeModifiedTemplates',
  'Admin.UiDesign.ResponsiveTemplatesQuickSearch',
  'Admin.UiDesign.ResponsiveTemplates.TotalRecords',
  'Admin.CancelDeleteWarning',
  'Admin.ResponsiveTemplates.SuccessfullyDeleted',
  'Admin.Responsive.CopyDefaultTemplate',
  'Admin.Responsive.GeneralInfo',
  'Admin.Responsive.Content',
  'Admin.Responsive.IfYouPressF11YouWillEnterFullscreenModeToExitFullscreenModePressF11OrEsc',
  'Admin.Msg.EditTitle',
  'Admin.ResponsiveTemplates.History',
  'Admin.ResponsiveTemplates.Template',
  'Admin.ResponsiveUITemplate.Title',
  'Versions.SelectExactlyTwoVersionToCompare',
  'Admin.Responsive.ResponsiveTemplatePages'
];
